import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/auth-required';
import { checkServerVersion } from "@/utils";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      redirect: '/',
      beforeEnter: AuthRequired,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home/index.vue'),
          meta: {
            breadcrumb: [
              { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
            ],
            pageTitle: 'sections.home.title',
          }
        },
        {
          path: '/page2',
          name: 'page-2',
          component: () => import('./views/Page2.vue')
        },
        ...(process.env.NODE_ENV === 'development' ? [{
          // Dev-only spike page, deliberately absent from navMenuItems.js.
          // Gated on NODE_ENV so it cannot exist in a staging or production build.
          path: '/dev/bunny-video',
          name: 'dev-bunny-video',
          component: () => import('./views/pages/DevTest/BunnyVideoTest/index.vue')
        }, {
          path: '/dev/learn-time',
          name: 'dev-learn-time',
          component: () => import('./views/pages/DevTest/LearnTimeSim/index.vue')
        }] : []),
        {
          path: '/demo',
          name: 'demo',
          component: () => import('./views/pages/PersonalInfo/index.vue'),
          children: [
            {
              path: 'form-validate',
              name: 'form-validate',
              component: () => import('./views/pages/Demo/Validate/FormValidate'),
              meta: {
                breadcrumb: [
                  { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
                ],
                pageTitle: 'sections.home.title',
              }
            }
          ]
        },
        {
          path: '/personal-info',
          name: 'personal-info',
          component: () => import('./views/pages/PersonalInfo/index.vue'),
          children: [
            {
              path: 'student',
              name: 'student',
              component: () => import('./views/pages/PersonalInfo/Student/index'),
              meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: { i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล" } },
                    { title: { i18n: 'sections.personal-info.student-profile.list.page-title', default: "รายชื่อนิสิต" }, active: true }
                ],
                pageTitle: 'sections.personal-info.student-profile.list.page-title',
              },
            },
            {
              path: 'student-add',
              name: 'student-add',
              component: () => import('./views/pages/PersonalInfo/Student/EditStudent'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.student-profile.list.page-title', default: "รายชื่อนิสิต"},
                    url: '/personal-info/student'
                  },
                  {
                    title: {i18n: 'sections.personal-info.student-profile.add.page-title', default: "เพิ่มข้อมูลนิสิต"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.student-profile.add.page-title',
              },
            },
            {
              path: 'student-edit/:id',
              name: 'student-edit',
              props: true,
              component: () => import('./views/pages/PersonalInfo/Student/EditStudent'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.student-profile.list.page-title', default: "รายชื่อนิสิต"},
                    url: '/personal-info/student'
                  },
                  {
                    title: {i18n: 'sections.personal-info.student-profile.edit.page-title', default: "แก้ไขข้อมูลนิสิต"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.student-profile.edit.page-title',
              },
            },

            {
              path: 'student-upload',
              name: 'personal-info-student-upload',
              component: () => import('./views/pages/PersonalInfo/StudentUpload/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {
                      i18n: 'sections.personal-info.student-upload.list.page-title',
                      default: "อัพโหลดข้อมูลนิสิต"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.personal-info.student-upload.list.page-title',
              },
            },

            {
              path: 'teacher',
              name: 'teacher',
              props: true,
              component: () => import('./views/pages/PersonalInfo/Teacher/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                    { title: { i18n: 'sections.personal-info.teacher-profile.list.page-title', default: "รายชื่ออาจารย์" }, active: true }
                ],
                pageTitle: 'sections.personal-info.teacher-profile.list.page-title',
              },
            },
            {
              path: 'teacher-add',
              name: 'teacher-add',
              component: () => import('./views/pages/PersonalInfo/Teacher/EditTeacher'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.teacher-profile.list.page-title', default: "รายชื่ออาจารย์"},
                    url: '/personal-info/teacher'
                  },
                  {
                    title: {i18n: 'sections.personal-info.teacher-profile.detail.page-title', default: "เพิ่มข้อมูลอาจารย์"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.teacher-profile.detail.page-title',
              },
            },
            {
              path: 'teacher-edit/:id',
              name: 'teacher-edit',
              props: true,
              component: () => import('./views/pages/PersonalInfo/Teacher/EditTeacher'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.teacher-profile.list.page-title', default: "รายชื่ออาจารย์"},
                    url: '/personal-info/teacher'
                  },
                  {
                    title: {i18n: 'sections.personal-info.teacher-profile.detail.page-title', default: "แก้ไขข้อมูลอาจารย์"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.teacher-profile.detail.page-title',
              },
            },

            {
              path: 'teacher-upload',
              name: 'personal-info-teacher-upload',
              component: () => import('./views/pages/PersonalInfo/TeacherUpload/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {
                      i18n: 'sections.personal-info.teacher-upload.list.page-title',
                      default: "อัพโหลดข้อมูลอาจารย์"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.personal-info.teacher-upload.list.page-title',
              },
            },


            {
              path: 'staff',
              name: 'staff',
              props: true,
              component: () => import('./views/pages/PersonalInfo/Staff/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  { title: { i18n: 'sections.personal-info.staff-profile.list.page-title', default: "รายชื่ออาจารย์" }, active: true }
                ],
                pageTitle: 'sections.personal-info.staff-profile.list.page-title',
              },
            },
            {
              path: 'staff-add',
              name: 'staff-add',
              component: () => import('./views/pages/PersonalInfo/Staff/EditStaff'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.staff-profile.list.page-title', default: "รายชื่อเจ้าหน้าที่"},
                    url: '/personal-info/staff'
                  },
                  {
                    title: {i18n: 'sections.personal-info.staff-profile.detail.page-title', default: "เพิ่มข้อมูลเจ้าหน้าที่"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.staff-profile.detail.page-title',
              },
            },
            {
              path: 'staff-edit/:id',
              name: 'staff-edit',
              props: true,
              component: () => import('./views/pages/PersonalInfo/Staff/EditStaff'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                  {
                    title: {i18n: 'sections.personal-info.staff-profile.list.page-title', default: "รายชื่ออาจารย์"},
                    url: '/personal-info/staff'
                  },
                  {
                    title: {i18n: 'sections.personal-info.staff-profile.detail.page-title', default: "แก้ไขข้อมูลอาจารย์"},
                    active: true
                  }
                ],
                pageTitle: 'sections.personal-info.staff-profile.detail.page-title',
              },
            },

          ]
        },
        {
          path: '/courses',
          name: 'courses',
          component: () => import('./views/pages/Courses/index.vue'),
          children: [
            {
              path: 'course-outline',
              name: 'course-outline',
              component: () => import('./views/pages/Courses/CourseOutline/index.vue'),
              meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: { i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน" } },
                    { title: { i18n: 'sections.courses.course-outline.list.page-title', default: "รายการรายวิชา" }, active: true }
                ],
                pageTitle: 'sections.courses.course-outline.list.page-title',
              },
            },
            {
              path: 'course-outline-edit/:id',
              name: 'course-outline-edit',
              props: true,
              component: () => import('./views/pages/Courses/CourseOutline/EditCourseOutline'),
              meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: { i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน" } },
                    {
                      title: {
                        i18n: 'sections.courses.course-outline.list.page-title',
                        default: "รายการรายวิชา"
                      },
                      url: "/courses/course-outline"
                    },
                    {
                      title: {
                        i18n: 'sections.courses.course-outline.edit.page-title',
                        default: "แก้ไขรายวิชาที่สอน"
                      }, active: true
                    }
                ],
                pageTitle: 'sections.courses.course-outline.edit.page-title',
              },
            },
            {
              path: 'course-outline-info/:id',
              name: 'course-outline-info',
              props: true,
              component: () => import('./views/pages/Courses/CourseOutlineInfo/index.vue')
            },
            {
              path: 'vdo-set',
              name: 'vdo-set',
              component: () => import('./views/pages/VdoSet/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {title: {i18n: 'sections.courses.vdo-set.list.page-title', default: "รายการชุดวิดีโอ"}, active: true}
                ],
                pageTitle: 'sections.courses.vdo-set.list.page-title',
              },
            },
            {
              path: 'vdo-set-edit/:courseOutlineId',
              name: 'vdo-set-edit',
              props: true,
              component: () => import('./views/pages/VdoSet/EditVdoSet.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {i18n: 'sections.courses.vdo-set.list.page-title', default: "รายการชุดวิดีโอ"},
                    url: "/courses/vdo-set"
                  },
                  {
                    title: {i18n: 'sections.courses.vdo-set.edit.page-title', default: "แก้ไขชุดวิดีโอ"},
                    active: true
                  }
                ],
                pageTitle: 'sections.courses.vdo-set.edit.page-title',
              },
            },
            {
              path: 'live-class-schedule',
              name: 'live-class-schedule',
              component: () => import('./views/pages/LiveClass/LiveClassSchedule/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {i18n: 'sections.courses.live-class-schedule.list.page-title', default: "ตารางบรรยายสด"},
                    active: true
                  }
                ],
                pageTitle: 'sections.courses.live-class-schedule.list.page-title',
              },
            },
            {
              path: 'live-class-schedule-add/:academicPeriodId',
              name: 'live-class-schedule-add',
              props: true,
              component: () => import('./views/pages/LiveClass/LiveClassSchedule/EditLiveClassSchedule.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {
                      i18n: 'sections.courses.live-class-schedule.list.page-title',
                      default: "ตารางบรรยายสด"
                    },
                    url: "/courses/live-class-schedule"
                  },
                  {
                    title: {
                      i18n: 'sections.courses.live-class-schedule.add.page-title',
                      default: "เพิ่มตารางบรรยายสด"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.courses.live-class-schedule.add.page-title',
              },
            },
            {
              path: 'live-class-schedule-edit/:academicPeriodId/:id',
              name: 'live-class-schedule-edit',
              props: true,
              component: () => import('./views/pages/LiveClass/LiveClassSchedule/EditLiveClassSchedule.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {
                      i18n: 'sections.courses.live-class-schedule.list.page-title',
                      default: "ตารางบรรยายสด"
                    },
                    url: "/courses/live-class-schedule"
                  },
                  {
                    title: {
                      i18n: 'sections.courses.live-class-schedule.edit.page-title',
                      default: "แก้ไขตารางบรรยายสด"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.courses.live-class-schedule.edit.page-title',
              },
            },
            {
              path: 'live-class-schedule-upload',
              name: 'live-class-schedule-upload',
              component: () => import('./views/pages/LiveClass/LiveClassScheduleUpload/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {i18n: 'sections.courses.live-class-schedule-upload.list.page-title', default: "อัพโหลดตารางบรรยายสด"},
                    active: true
                  }
                ],
                pageTitle: 'sections.courses.live-class-schedule-upload.list.page-title',
              },
            },
            {
              path: 'vdo-live-set',
              name: 'vdo-live-set',
              component: () => import('./views/pages/LiveClass/VdoLiveSet/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {i18n: 'sections.courses.vdo-live-set.list.page-title', default: "วิดีโอบรรยายสด"},
                    active: true
                  }
                ],
                pageTitle: 'sections.courses.vdo-live-set.list.page-title',
              },
            },
            {
              path: 'vdo-live-set-edit/:liveClassScheduleId',
              name: 'vdo-live-set-edit',
              props: true,
              component: () => import('./views/pages/LiveClass/VdoLiveSet/EditVdoLiveSet.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {
                      i18n: 'sections.courses.vdo-live-set.list.page-title',
                      default: "วิดีโอบรรยายสด"
                    },
                    url: "/courses/vdo-live-set"
                  },
                  {
                    title: {
                      i18n: 'sections.courses.vdo-live-set.edit.page-title',
                      default: "แก้ไขวิดีโอบรรยายสด"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.courses.vdo-live-set.edit.page-title',
              },
            },
            {
              path: 'advisor-online-schedule',
              name: 'advisor-online-schedule',
              component: () => import('./views/pages/Advisor/AdvisorOnlineSchedule/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {i18n: 'sections.courses.advisor-online-schedule.list.page-title', default: "ตารางพบอาจารย์ที่ปรึกษา"},
                    active: true
                  }
                ],
                pageTitle: 'sections.courses.advisor-online-schedule.list.page-title',
              },
            },
            {
              path: 'advisor-online-schedule-add/:academicPeriodId',
              name: 'advisor-online-schedule-add',
              props: true,
              component: () => import('./views/pages/Advisor/AdvisorOnlineSchedule/EditAdvisorOnlineSchedule.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {
                      i18n: 'sections.courses.advisor-online-schedule.list.page-title',
                      default: "ตารางพบอาจารย์ที่ปรึกษา"
                    },
                    url: "/courses/advisor-online-schedule"
                  },
                  {
                    title: {
                      i18n: 'sections.courses.advisor-online-schedule.add.page-title',
                      default: "เพิ่มตารางพบอาจารย์ที่ปรึกษา"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.courses.advisor-online-schedule.add.page-title',
              },
            },
            {
              path: 'advisor-online-schedule-edit/:academicPeriodId/:id',
              name: 'advisor-online-schedule-edit',
              props: true,
              component: () => import('./views/pages/Advisor/AdvisorOnlineSchedule/EditAdvisorOnlineSchedule'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.courses.title', default: "จัดการข้อมูลการสอน"}},
                  {
                    title: {
                      i18n: 'sections.courses.advisor-online-schedule.list.page-title',
                      default: "ตารางพบอาจารย์ที่ปรึกษา"
                    },
                    url: "/courses/advisor-online-schedule"
                  },
                  {
                    title: {
                      i18n: 'sections.courses.advisor-online-schedule.edit.page-title',
                      default: "แก้ไขตารางพบอาจารย์ที่ปรึกษา"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.courses.advisor-online-schedule.edit.page-title',
              },
            },
          ]
        },
        {
          name: 'registration',
          path: '/registration',
          component: () => import('./views/pages/Courses/index.vue'),
          children: [
            {
              path: 'course-outline-registration',
              name: 'course-outline-registration',
              // component: () => import('./views/pages/Registration/CourseOutlineRegistration/index.vue'),//old
              component: () => import('./views/pages/Registration/CourseOutlineRegistration/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.list.page-title',
                      default: "รายวิชาที่เปิดให้ลงทะเบียน"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.registration.course-outline-registration.list.page-title',
              },
            },
            {
              path: 'course-outline-registration-add/:academicPeriodId',
              name: 'course-outline-registration-add',
              props: true,
              component: () => import('./views/pages/Registration/CourseOutlineRegistration/SubComponents/CourseOutlineRegistrationAdd.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.list.page-title',
                      default: "รายวิชาที่เปิดให้ลงทะเบียน"
                    },
                    url: "/registration/course-outline-registration"
                  },
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.add.page-title',
                      default: "เปิดวิชาให้ลงทะเบียน"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.registration.course-outline-registration.add.page-title',
              },
            },
            {
              path: 'course-outline-registration-edit/:courseOutlineRegistrationId/:courseOutlineId',
              name: 'course-outline-registration-edit',
              props: true,
              component: () => import('./views/pages/Registration/CourseOutlineRegistration/SubComponents/CourseOutlineRegistrationEdit.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.list.page-title',
                      default: "รายวิชาที่เปิดให้ลงทะเบียน"
                    },
                    url: "/registration/course-outline-registration"
                  },
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.edit.page-title',
                      default: "รายละเอียดแต่ล่ะ Section"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.registration.course-outline-registration.edit.page-title',
              },
            },
            /*{
              path: 'class-section/:id',
              name: 'class-section',
              props: true,
              component: () => import('./views/pages/Registration/ClassSection/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.course-outline-registration.list.page-title',
                      default: "รายวิชาที่เปิดให้ลงทะเบียน"
                    }, url: "/registration/course-outline-registration"
                  },
                  {
                    title: {i18n: 'sections.registration.class-section.list.page-title', default: "หัวข้อการเรียน"},
                    active: true
                  }
                ],
                pageTitle: 'sections.registration.class-section.list.page-title',
              },
            },*/
            {
              path: 'student-enroll',
              name: 'student-enroll',
              component: () => import('./views/pages/Registration/StudentEnroll/index.vue'),
              // component: () => import('./views/pages/Registration/StudentEnroll/Main/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {i18n: 'sections.registration.student-enroll.list.page-title', default: "ลงทะเบียนเรียน"},
                    active: true
                  }
                ],
                pageTitle: 'sections.registration.student-enroll.list.page-title',
              },
            },
            {
              path: 'student-enroll-add/:studentId/:academicPeriodId/:studentEnrollId',
              name: 'student-enroll-add',
              props: true,
              component: () => import('./views/pages/Registration/StudentEnroll/SubComponents/StudentEnrollAdd.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {i18n: 'sections.registration.student-enroll.list.page-title', default: "ลงทะเบียนเรียน"},
                    url: "/registration/student-enroll"
                  },
                  {
                    title: {i18n: 'sections.registration.student-enroll.add.page-title', default: "เพิ่มวิชาลงทะเบียน"},
                    active: true
                  }
                ],
                pageTitle: 'sections.registration.student-enroll.add.page-title',
              },
            },
            {
              path: 'student-enroll-upload',
              name: 'student-enroll-upload',
              component: () => import('./views/pages/Registration/StudentEnrollUpload/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.student-enroll-upload.list.page-title',
                      default: "อัพโหลดไฟล์ลงทะเบียน"
                    }, active: true
                  }
                ],
                pageTitle: 'sections.registration.student-enroll-upload.list.page-title',
              },
            },
            /*{
              path: 'student-enroll-detail/:studentEnrollId',
              name: 'student-enroll-detail',
              props: true,
              component: () => import('./views/pages/Registration/StudentEnroll/Detail/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.registration.title', default: "จัดการการลงทะเบียน"}},
                  {
                    title: {
                      i18n: 'sections.registration.student-enroll.list.page-title',
                      default: "ลงทะเบียนเรียนนิสิต"
                    }, url: "/registration/student-enroll"
                  },
                  {
                    title: {i18n: 'sections.registration.student-enroll.detail.list.breadcrumb', default: "รายละเอียด"},
                    active: true
                  }
                ],
                pageTitle: 'sections.registration.student-enroll.detail.list.breadcrumb',
              },
            }*/
          ]
        },
        {
          name: 'examination',
          path: '/examination',
          component: () => import('./views/pages/Examination/index.vue'),
          children: [
            {
              path: 'exam',
              name: 'exam',
              component: () => import('./views/pages/Examination/Exam/index.vue'),
              meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                    { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, active: true }
                ],
                pageTitle: 'sections.examination.exam.list.page-title',
              },
            },
            {
              path: 'exam-question/:id/:subjectId/:teacherId',
              name: 'exam-question',
              props: true,
              component: () => import('./views/pages/Examination/Exam/SubComponents/ExamQuestionList.vue'),
              meta: {
                breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                    { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, url: "/examination/exam" },
                    { title: { i18n: 'sections.examination.exam.subject.list.page-title', default: "รายการคำถามในรายวิชา" }, active: true }
                ],
                pageTitle: 'sections.examination.exam.subject.list.page-title',
              },
            },
            {
              path: 'exam-question-add/:examId/:subjectId/:teacherId',
              name: 'exam-question-add',
              props: true,
              component: () => import('./views/pages/Examination/Exam/SubComponents/ExamQuestionEdit.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                  { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, url: "/examination/exam" },
                  { title: { i18n: 'sections.examination.exam.subject.list.page-title', default: "รายการคำถามในรายวิชา" }, url: "exam-question/:id/:subjectId/:teacherId" },
                  { title: { i18n: 'sections.examination.exam.subject.add.page-title', default: "เพิ่มคำถาม" }, active: true },
                ],
                pageTitle: 'sections.examination.exam.subject.add.page-title',
              },
            },
            {
              path: 'exam-question-edit/:id/:examId/:subjectId/:teacherId',
              name: 'exam-question-edit',
              props: true,
              component: () => import('./views/pages/Examination/Exam/SubComponents/ExamQuestionEdit.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                  { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, url: "/examination/exam" },
                  { title: { i18n: 'sections.examination.exam.subject.list.page-title', default: "รายการคำถามในรายวิชา" }, url: "exam-question/:id/:subjectId/:teacherId" },
                  { title: { i18n: 'sections.examination.exam.subject.edit.page-title', default: "แก้ไขคำถาม" }, active: true },
                ],
                pageTitle: 'sections.examination.exam.subject.edit.page-title',
              },
            },
            {
              path: 'exam-upload',
              name: 'exam-upload',
              component: () => import('./views/pages/Examination/ExamUpload/index.vue'),
              meta: {
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                  { title: { i18n: 'sections.examination.exam-upload.list.page-title', default: "อัพโหลดข้อสอบ" }, active: true }
                ],
                pageTitle: 'sections.examination.exam-upload.list.page-title',
              },
            },
          ]
        },
        {
          name: 'manageClassRoom',
          path: '/class-room',
          component: () => import('./views/pages/ClassRoom/index.vue'),
          children: [
            {
              path: 'class-room',
              name: 'class-room',
              component: () => import('./views/pages/ClassRoom/ClassRoom/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room.class-room', default: "ห้องเรียน"},
                    active: true,
                    url: "/class-room/class-room"
                  },
                ],
                pageTitle: 'class-room.class-room',
              },
            },
            {
              path: 'class-room-add',
              name: 'class-room-add',
              props: true,
              component: () => import('./views/pages/ClassRoom/ClassRoom/EditClassRoom.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {title: {i18n: 'class-room.class-room', default: "ห้องเรียน"}, url: "/class-room/class-room"},
                  {title: {i18n: 'class-room.class-room-manage', default: "จัดการห้องเรียน"}, active: true}
                ],
                pageTitle: 'class-room.class-room',
              },
            },
            {
              path: 'class-room-edit/:id',
              name: 'class-room-edit',
              props: true,
              component: () => import('./views/pages/ClassRoom/ClassRoom/EditClassRoom.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {title: {i18n: 'class-room.class-room', default: "ห้องเรียน"}, url: "/class-room/class-room"},
                  {title: {i18n: 'class-room.class-room', default: "แก้ไขห้องเรียน"}, active: true}
                ],
                pageTitle: 'class-room.class-room',
              },
            },
            {
              path: 'class-room-type',
              name: 'class-room-type',
              component: () => import('./views/pages/ClassRoom/ClassRoomType/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-type.class-room-type', default: "ประเภทห้องเรียน"},
                    active: true,
                    url: "/class-room/class-room-type"
                  },
                ],
                pageTitle: 'class-room-type.class-room-type',
              },
            },
            {
              path: 'class-room-type-add',
              name: 'class-room-type-add',
              prop: true,
              component: () => import('./views/pages/ClassRoom/ClassRoomType/EditClassRoomType'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-type.class-room-type', default: "ประเภทห้องเรียน"},
                    active: true,
                    url: "/class-room/class-room-type"
                  },
                  {title: {i18n: 'sections.class-room.class-room-type.edit.page-title', default: "เพิ่มประเภทห้องเรียน"}, active: true}
                ],
                pageTitle: 'sections.class-room.class-room-type.edit.page-title',
              },
            },
            {
              path: 'class-room-type-edit/:id',
              name: 'class-room-type-edit',
              prop: true,
              component: () => import('./views/pages/ClassRoom/ClassRoomType/EditClassRoomType'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-type.class-room-type', default: "ประเภทห้องเรียน"},
                    active: true,
                    url: "/class-room/class-room-type"
                  },
                  {title: {i18n: 'sections.class-room.class-room-type.edit.page-title', default: "แก้ไขประเภทห้องเรียน"}, active: true}
                ],
                pageTitle: 'sections.class-room.class-room-type.edit.page-title',
              },
            },
            {
              path: 'class-room-owned',
              name: 'class-room-owned',
              component: () => import('./views/pages/ClassRoom/ClassRoomOwned/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-owned.class-room-owned', default: "ห้องเรียที่มี"},
                    active: true,
                    url: "/class-room/class-room-owned"
                  },
                ],
                pageTitle: 'class-room-owned.class-room-owned',
              },
            },
            {
              path: 'class-room-owned-add',
              name: 'class-room-owned-add',
              prop: true,
              component: () => import('./views/pages/ClassRoom/ClassRoomOwned/EditClassRoomOwned.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-owned.class-room-owned', default: "ห้องเรียที่มี"},
                    active: true,
                    url: "/class-room/class-room-owned"
                  },
                  {title: {i18n: 'sections.class-room.class-room-owned.add.page-title', default: "เพิ่มห้องเรียที่มี"}, active: true}
                ],
                pageTitle: 'sections.class-room.class-room-owned.add.page-title',
              },
            },
            {
              path: 'class-room-owned-edit/:id',
              name: 'class-room-owned-edit',
              prop: true,
              component: () => import('./views/pages/ClassRoom/ClassRoomOwned/EditClassRoomOwned.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'class-room.nav', default: "จัดการห้องเรียน"}},
                  {
                    title: {i18n: 'class-room-owned.class-room-owned', default: "ประเภทห้องเรียน"},
                    active: true,
                    url: "/class-room/class-room-owned"
                  },
                  {title: {i18n: 'sections.class-room.class-room-owned.edit.page-title', default: "แก้ไขปห้องเรียที่มี"}, active: true}
                ],
                pageTitle: 'class-room-owned.class-room-owned',
              },
            },
          ]
        },
        {
          name: 'common-data',
          path: '/common-data',
          component: () => import('./views/pages/ClassRoom/index.vue'),
          children: [
            // DEGREE
            {
              path: 'degree',
              name: 'degree',
              component: () => import('./views/pages/CommonData/Degree/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.degree.list.page-title', default: "ระดับการศึกษา"},
                    active: true,
                    url: "/common-data/degree"
                  },
                ],
                pageTitle: 'sections.common-data.degree.list.page-title',
              },
            },
            {
              path: 'degree-add',
              name: 'degree-add',
              props: true,
              component: () => import('./views/pages/CommonData/Degree/EditDegree'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ระดับการศึกษา"}},
                  {title: {i18n: 'sections.common-data.degree.list.page-title', default: "ข้อมูลระดับการศึกษา"}, url: "/common-data/degree"},
                  {title: {i18n: 'sections.common-data.degree.add.page-title', default: "เพิ่มระดับการศึกษา"}, active: true}
                ],
                pageTitle: 'sections.common-data.degree.add.page-title',
              },
            },
            {
              path: 'degree-edit/:id',
              name: 'degree-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Degree/EditDegree'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ระดับการศึกษา"}},
                  {title: {i18n: 'sections.common-data.degree.list.page-title', default: "ข้อมูลระดับการศึกษา"}, url: "/common-data/degree"},
                  {title: {i18n: 'sections.common-data.degree.edit.page-title', default: "แก้ไขระดับการศึกษา"}, active: true}
                ],
                pageTitle: 'sections.common-data.degree.edit.page-title',
              },
            },
            // FACULTY
            {
              path: 'faculty',
              name: 'faculty',
              component: () => import('./views/pages/CommonData/Faculty/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.faculty.list.page-title', default: "คณะ"},
                    active: true,
                    url: "/common-data/faculty"
                  },
                ],
                pageTitle: 'sections.common-data.faculty.list.page-title',
              },
            },
            {
              path: 'faculty-add',
              name: 'faculty-add',
              props: true,
              component: () => import('./views/pages/CommonData/Faculty/EditFaculty'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "คณะ"}},
                  {title: {i18n: 'sections.common-data.faculty.list.page-title', default: "ข้อมูลคณะ"}, url: "/common-data/faculty"},
                  {title: {i18n: 'sections.common-data.faculty.add.page-title', default: "เพิ่มคณะ"}, active: true}
                ],
                pageTitle: 'sections.common-data.faculty.add.page-title',
              },
            },
            {
              path: 'faculty-edit/:id',
              name: 'faculty-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Faculty/EditFaculty'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "คณะ"}},
                  {title: {i18n: 'sections.common-data.faculty.list.page-title', default: "ข้อมูลคณะ"}, url: "/common-data/faculty"},
                  {title: {i18n: 'sections.common-data.faculty.edit.page-title', default: "แก้ไขคณะ"}, active: true}
                ],
                pageTitle: 'sections.common-data.faculty.edit.page-title',
              },
            },
            // DEPARTMENT
            {
              path: 'department',
              name: 'department',
              component: () => import('./views/pages/CommonData/Department/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.department.list.page-title', default: "สาขา"},
                    active: true,
                    url: "/common-data/department"
                  },
                ],
                pageTitle: 'sections.common-data.department.list.page-title',
              },
            },
            {
              path: 'department-add',
              name: 'department-add',
              props: true,
              component: () => import('./views/pages/CommonData/Department/EditDepartment'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "สาขา"}},
                  {title: {i18n: 'sections.common-data.department.list.page-title', default: "ข้อมูลสาขา"}, url: "/common-data/department"},
                  {title: {i18n: 'sections.common-data.department.add.page-title', default: "เพิ่มสาขา"}, active: true}
                ],
                pageTitle: 'sections.common-data.department.add.page-title',
              },
            },
            {
              path: 'department-edit/:id',
              name: 'department-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Department/EditDepartment'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "สาขา"}},
                  {title: {i18n: 'sections.common-data.department.list.page-title', default: "ข้อมูลสาขา"}, url: "/common-data/department"},
                  {title: {i18n: 'sections.common-data.department.edit.page-title', default: "แก้ไขสาขา"}, active: true}
                ],
                pageTitle: 'sections.common-data.department.edit.page-title',
              },
            },
            // SUBJECT GROUP
            {
              path: 'subject-group',
              name: 'subject-group',
              component: () => import('./views/pages/CommonData/SubjectGroup/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.subject-group.list.page-title', default: "กลุ่มวิชา"},
                    active: true,
                    url: "/common-data/subject-group"
                  },
                ],
                pageTitle: 'sections.common-data.subject-group.list.page-title',
              },
            },
            {
              path: 'subject-group-add',
              name: 'subject-group-add',
              props: true,
              component: () => import('./views/pages/CommonData/SubjectGroup/EditSubjectGroup'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "กลุ่มวิชา"}},
                  {title: {i18n: 'sections.common-data.subject-group.list.page-title', default: "ข้อมูลกลุ่มวิชา"}, url: "/common-data/subject-group"},
                  {title: {i18n: 'sections.common-data.subject-group.add.page-title', default: "เพิ่มกลุ่มวิชา"}, active: true}
                ],
                pageTitle: 'sections.common-data.subject-group.add.page-title',
              },
            },
            {
              path: 'subject-group-edit/:id',
              name: 'subject-group-edit',
              props: true,
              component: () => import('./views/pages/CommonData/SubjectGroup/EditSubjectGroup'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "กลุ่มวิชา"}},
                  {title: {i18n: 'sections.common-data.subject-group.list.page-title', default: "ข้อมูลกลุ่มวิชา"}, url: "/common-data/subject-group"},
                  {title: {i18n: 'sections.common-data.subject-group.edit.page-title', default: "แก้ไขกลุ่มวิชา"}, active: true}
                ],
                pageTitle: 'sections.common-data.subject-group.edit.page-title',
              },
            },
            // SUBJECT
            {
              path: 'subject',
              name: 'subject',
              component: () => import('./views/pages/CommonData/Subject/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.subject.list.page-title', default: "วิชา"},
                    active: true,
                    url: "/common-data/subject"
                  },
                ],
                pageTitle: 'sections.common-data.subject.list.page-title',
              },
            },
            {
              path: 'subject-add',
              name: 'subject-add',
              props: true,
              component: () => import('./views/pages/CommonData/Subject/EditSubject'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "วิชา"}},
                  {title: {i18n: 'sections.common-data.subject.list.page-title', default: "ข้อมูลวิชา"}, url: "/common-data/subject"},
                  {title: {i18n: 'sections.common-data.subject.add.page-title', default: "เพิ่มวิชา"}, active: true}
                ],
                pageTitle: 'sections.common-data.subject.add.page-title',
              },
            },
            {
              path: 'subject-edit/:id',
              name: 'subject-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Subject/EditSubject'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "วิชา"}},
                  {title: {i18n: 'sections.common-data.subject.list.page-title', default: "ข้อมูลวิชา"}, url: "/common-data/subject"},
                  {title: {i18n: 'sections.common-data.subject.edit.page-title', default: "แก้ไขวิชา"}, active: true}
                ],
                pageTitle: 'sections.common-data.subject.edit.page-title',
              },
            },
            // ACADEMIC PERIOD
            {
              path: 'academic-period',
              name: 'academic-period',
              component: () => import('./views/pages/CommonData/AcademicPeriod/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.academic-period.list.page-title', default: "ข้อมูลปีการศึกษา"},
                    active: true,
                    url: "/common-data/academic-period"
                  },
                ],
                pageTitle: 'sections.common-data.academic-period.list.page-title',
              },
            },
            {
              path: 'academic-period-add',
              name: 'academic-period-add',
              props: true,
              component: () => import('./views/pages/CommonData/AcademicPeriod/EditAcademicPeriod.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ปีการศึกษา"}},
                  {title: {i18n: 'sections.common-data.academic-period.list.page-title', default: "ข้อมูลปีการศึกษา"}, url: "/common-data/academic-period"},
                  {title: {i18n: 'sections.common-data.academic-period.add.page-title', default: "เพิ่มปีการศึกษา"}, active: true}
                ],
                pageTitle: 'sections.common-data.academic-period.add.page-title',
              },
            },
            {
              path: 'academic-period-edit/:id',
              name: 'academic-period-edit',
              props: true,
              component: () => import('./views/pages/CommonData/AcademicPeriod/EditAcademicPeriod.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ปีการศึกษา"}},
                  {title: {i18n: 'sections.common-data.academic-period.list.page-title', default: "ข้อมูลปีการศึกษา"}, url: "/common-data/academic-period"},
                  {title: {i18n: 'sections.common-data.academic-period.edit.page-title', default: "แก้ไขปีการศึกษา"}, active: true}
                ],
                pageTitle: 'sections.common-data.academic-period.edit.page-title',
              },
            },
            // PREFIX
            {
              path: 'prefix',
              name: 'prefix',
              component: () => import('./views/pages/CommonData/Prefix/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.prefix.list.page-title', default: "ข้อมูลคำนำหน้า"},
                    active: true,
                    url: "/common-data/prefix"
                  },
                ],
                pageTitle: 'sections.common-data.prefix.list.page-title',
              },
            },
            {
              path: 'prefix-add',
              name: 'prefix-add',
              props: true,
              component: () => import('./views/pages/CommonData/Prefix/EditPrefix.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "คำนำหน้า"}},
                  {title: {i18n: 'sections.common-data.prefix.list.page-title', default: "ข้อมูลคำนำหน้า"}, url: "/common-data/prefix"},
                  {title: {i18n: 'sections.common-data.prefix.add.page-title', default: "เพิ่มคำนำหน้า"}, active: true}
                ],
                pageTitle: 'sections.common-data.prefix.add.page-title',
              },
            },
            {
              path: 'prefix-edit/:id',
              name: 'prefix-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Prefix/EditPrefix.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "คำนำหน้า"}},
                  {title: {i18n: 'sections.common-data.prefix.list.page-title', default: "ข้อมูลคำนำหน้า"}, url: "/common-data/prefix"},
                  {title: {i18n: 'sections.common-data.prefix.edit.page-title', default: "แก้ไขคำนำหน้า"}, active: true}
                ],
                pageTitle: 'sections.common-data.prefix.edit.page-title',
              },
            },
            // PROJECT
            {
              path: 'project',
              name: 'project',
              component: () => import('./views/pages/CommonData/Project/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.project.list.page-title', default: "ข้อมูลโครงการ"},
                    active: true,
                    url: "/common-data/project"
                  },
                ],
                pageTitle: 'sections.common-data.project.list.page-title',
              },
            },
            {
              path: 'project-add',
              name: 'project-add',
              props: true,
              component: () => import('./views/pages/CommonData/Project/EditProject.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "โครงการ"}},
                  {title: {i18n: 'sections.common-data.project.list.page-title', default: "ข้อมูลโครงการ"}, url: "/common-data/project"},
                  {title: {i18n: 'sections.common-data.project.add.page-title', default: "เพิ่มโครงการ"}, active: true}
                ],
                pageTitle: 'sections.common-data.project.add.page-title',
              },
            },
            {
              path: 'project-edit/:id',
              name: 'project-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Project/EditProject.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "โครงการ"}},
                  {title: {i18n: 'sections.common-data.project.list.page-title', default: "ข้อมูลโครงการ"}, url: "/common-data/project"},
                  {title: {i18n: 'sections.common-data.project.edit.page-title', default: "แก้ไขโครงการ"}, active: true}
                ],
                pageTitle: 'sections.common-data.project.edit.page-title',
              },
            },
            // STUDENT STATUS
            {
              path: 'student-status',
              name: 'student-status',
              component: () => import('./views/pages/CommonData/StudentStatus/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.student-status.list.page-title', default: "ข้อมูลสถานะภาพนิสิต"},
                    active: true,
                    url: "/common-data/student-status"
                  },
                ],
                pageTitle: 'sections.common-data.student-status.list.page-title',
              },
            },
            {
              path: 'student-status-add',
              name: 'student-status-add',
              props: true,
              component: () => import('./views/pages/CommonData/StudentStatus/EditStudentStatus.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "สถานะภาพนิสิต"}},
                  {title: {i18n: 'sections.common-data.student-status.list.page-title', default: "ข้อมูลสถานะภาพนิสิต"}, url: "/common-data/student-status"},
                  {title: {i18n: 'sections.common-data.student-status.add.page-title', default: "เพิ่มสถานะภาพนิสิต"}, active: true}
                ],
                pageTitle: 'sections.common-data.student-status.add.page-title',
              },
            },
            {
              path: 'student-status-edit/:id',
              name: 'student-status-edit',
              props: true,
              component: () => import('./views/pages/CommonData/StudentStatus/EditStudentStatus.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "สถานะภาพนิสิต"}},
                  {title: {i18n: 'sections.common-data.student-status.list.page-title', default: "ข้อมูลสถานะภาพนิสิต"}, url: "/common-data/student-status"},
                  {title: {i18n: 'sections.common-data.student-status.edit.page-title', default: "แก้ไขสถานะภาพนิสิต"}, active: true}
                ],
                pageTitle: 'sections.common-data.student-status.edit.page-title',
              },
            },
            // CURRICULUM
            {
              path: 'curriculum',
              name: 'curriculum',
              component: () => import('./views/pages/CommonData/Curriculum/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.curriculum.list.page-title', default: "ข้อมูลหลักสูตร"},
                    active: true,
                    url: "/common-data/curriculum"
                  },
                ],
                pageTitle: 'sections.common-data.curriculum.list.page-title',
              },
            },
            {
              path: 'curriculum-add',
              name: 'curriculum-add',
              props: true,
              component: () => import('./views/pages/CommonData/Curriculum/EditCurriculum.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "หลักสูตร"}},
                  {title: {i18n: 'sections.common-data.curriculum.list.page-title', default: "ข้อมูลหลักสูตร"}, url: "/common-data/curriculum"},
                  {title: {i18n: 'sections.common-data.curriculum.add.page-title', default: "เพิ่มหลักสูตร"}, active: true}
                ],
                pageTitle: 'sections.common-data.curriculum.add.page-title',
              },
            },
            {
              path: 'curriculum-edit/:id',
              name: 'curriculum-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Curriculum/EditCurriculum.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "หลักสูตร"}},
                  {title: {i18n: 'sections.common-data.curriculum.list.page-title', default: "ข้อมูลหลักสูตร"}, url: "/common-data/curriculum"},
                  {title: {i18n: 'sections.common-data.curriculum.edit.page-title', default: "แก้ไขหลักสูตร"}, active: true}
                ],
                pageTitle: 'sections.common-data.curriculum.edit.page-title',
              },
            },
            // ASSESSMENT
            {
              path: 'assessment',
              name: 'assessment',
              component: () => import('./views/pages/CommonData/Assessment/index.vue'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "ข้อมูลทั่วไป"}},
                  {
                    title: {i18n: 'sections.common-data.assessment.list.page-title', default: "ข้อมูลหลักเกณฑ์"},
                    active: true,
                    url: "/common-data/assessment"
                  },
                ],
                pageTitle: 'sections.common-data.assessment.list.page-title',
              },
            },
            {
              path: 'assessment-add',
              name: 'assessment-add',
              props: true,
              component: () => import('./views/pages/CommonData/Assessment/EditAssessment'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "หลักเกณฑ์"}},
                  {title: {i18n: 'sections.common-data.assessment.list.page-title', default: "ข้อมูลหลักเกณฑ์"}, url: "/common-data/assessment"},
                  {title: {i18n: 'sections.common-data.assessment.add.page-title', default: "เพิ่มหลักเกณฑ์"}, active: true}
                ],
                pageTitle: 'sections.common-data.assessment.add.page-title',
              },
            },
            {
              path: 'assessment-edit/:id',
              name: 'assessment-edit',
              props: true,
              component: () => import('./views/pages/CommonData/Assessment/EditAssessment'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.common-data.nav', default: "หลักเกณฑ์"}},
                  {title: {i18n: 'sections.common-data.assessment.list.page-title', default: "ข้อมูลหลักเกณฑ์"}, url: "/common-data/assessment"},
                  {title: {i18n: 'sections.common-data.assessment.edit.page-title', default: "แก้ไขหลักเกณฑ์"}, active: true}
                ],
                pageTitle: 'sections.common-data.assessment.edit.page-title',
              },
            },
          ]
        },
        {
          name: 'system',
          path: '/system',
          component: () => import('./views/pages/ClassRoom/index.vue'),
          children: [
            // RESET PASSWORD
            {
              path: 'reset-password',
              name: 'reset-password',
              component: () => import('./views/pages/System/ResetPassword'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.system.title', default: "ข้อมูลผู้ใช้ระบบ"}},
                  /*{
                    title: {i18n: 'sections.system.reset-password.title', default: "รีเซ็ตรหัสผ่าน"},
                    active: true,
                    url: "/system/reset-password"
                  },*/
                ],
                pageTitle: 'sections.system.reset-password.title',
              },
            },
            // SYSTEM CONFIG
            {
              path: 'system-config',
              name: 'system-config',
              component: () => import('./views/pages/System/SystemConfig'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.system.system-config.title', default: "ข้อมูลระบบ"}},
                ],
                pageTitle: 'sections.system.system-config.title',
              },
            },
            {
              path: 'vdo-migration',
              name: 'vdo-migration',
              component: () => import('@/views/pages/System/VdoMigration/index.vue'),
              meta: {
                pageTitle: 'vdo-migration.title',
                breadcrumb: [
                  { title: 'Home', url: '/' },
                  { title: { i18n: 'vdo-migration.title', default: 'สถานะการย้ายวิดีโอไป Bunny' }, active: true }
                ]
              }
            },
          ]
        },
        {
          name: 'university-news',
          path: '/university-news',
          component: () => import('./views/pages/UniversityNews/index.vue'),
          children: [
            // INFO GROUP
            {
              path: 'info-group',
              name: 'info-group',
              component: () => import('./views/pages/UniversityNews/InfoGroup/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย" } },
                  { title: { i18n: 'sections.university-news.info-group.title', default: "ประเภทของประกาศ" }, active: true }
                ],
                pageTitle: 'sections.university-news.info-group.title',
              },
            },
            {
              path: 'info-group-add',
              name: 'info-group-add',
              props: true,
              component: () => import('./views/pages/UniversityNews/InfoGroup/EditInfoGroup'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย"}},
                  {title: {i18n: 'sections.university-news.info-group.title', default: "ประเภทของประกาศ"}, url: "/university-news/info-group"},
                  {title: {i18n: 'sections.university-news.info-group.add', default: "เพิ่มประเภทของประกาศ"}, active: true}
                ],
                pageTitle: 'sections.university-news.info-group.add',
              },
            },
            {
              path: 'info-group-edit/:id',
              name: 'info-group-edit',
              props: true,
              component: () => import('./views/pages/UniversityNews/InfoGroup/EditInfoGroup'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย"}},
                  {title: {i18n: 'sections.university-news.info-group.title', default: "ประเภทของประกาศ"}, url: "/university-news/info-group"},
                  {title: {i18n: 'sections.university-news.info-group.edit', default: "แก้ไขประเภทของประกาศ"}, active: true}
                ],
                pageTitle: 'sections.university-news.info-group.edit',
              },
            },
            // INFO TOPIC
            {
              path: 'info-topic',
              name: 'info-topic',
              component: () => import('./views/pages/UniversityNews/InfoTopic/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย" } },
                  { title: { i18n: 'sections.university-news.info-topic.title', default: "จัดการเนื้อหา" }, active: true }
                ],
                pageTitle: 'sections.university-news.info-topic.title',
              },
            },
            {
              path: 'info-topic-add',
              name: 'info-topic-add',
              props: true,
              component: () => import('./views/pages/UniversityNews/InfoTopic/EditInfoTopic'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย"}},
                  {title: {i18n: 'sections.university-news.info-topic.title', default: "จัดการเนื้อหา"}, url: "/university-news/info-topic"},
                  {title: {i18n: 'sections.university-news.info-topic.add', default: "เพิ่มเนื้อหา"}, active: true}
                ],
                pageTitle: 'sections.university-news.info-topic.add',
              },
            },
            {
              path: 'info-topic-edit/:id',
              name: 'info-topic-edit',
              props: true,
              component: () => import('./views/pages/UniversityNews/InfoTopic/EditInfoTopic'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  {title: {i18n: 'sections.university-news.title', default: "ประกาศจากมหาวิทยาลัย"}},
                  {title: {i18n: 'sections.university-news.info-topic.title', default: "จัดการเนื้อหา"}, url: "/university-news/info-topic"},
                  {title: {i18n: 'sections.university-news.info-topic.edit', default: "แก้ไขเนื้อหา"}, active: true}
                ],
                pageTitle: 'sections.university-news.info-topic.edit',
              },
            },
          ]
        },
        {
          name: 'upload',
          path: '/upload',
          component: () => import('./views/pages/Upload/index.vue'),
          children: [
            // UPLOAD YEALINK DATA - LIVE CLASS SCHEDULE
            {
              path: 'live-class-record',
              name: 'live-class-record',
              component: () => import('./views/pages/Upload/YeaLink/LiveClassRecord/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.upload.title', default: "อัพโหลด" } },
                  { title: { i18n: 'sections.upload.yea-link.live-class-record.title', default: "บันทึกการเข้าบรรยายสด" }, active: true }
                ],
                pageTitle: 'sections.upload.yea-link.live-class-record.title',
              },
            },
            // UPLOAD YEALINK DATA - ADVISOR ONLINE RECORD
            {
              path: 'advisor-online-record',
              name: 'advisor-online-record',
              component: () => import('./views/pages/Upload/YeaLink/AdvisorOnlineRecord/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.upload.title', default: "อัพโหลด" } },
                  { title: { i18n: 'sections.upload.yea-link.advisor-online-record.title', default: "บันทึกการพบอาจารย์" }, active: true }
                ],
                pageTitle: 'sections.upload.yea-link.advisor-online-record.title',
              },
            },
          ]
        },
        {
          name: 'report',
          path: '/report',
          component: () => import('./views/pages/Report/index.vue'),
          children: [
            // STUDENT STAT
            {
              path: 'student-stat',
              name: 'student-stat',
              component: () => import('./views/pages/Report/StudentStat/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.report.title', default: "รายงาน" } },
                  { title: { i18n: 'sections.report.student-stat.title', default: "สถิติการเข้าเรียน" }, active: true }
                ],
                pageTitle: 'sections.report.student-stat.title',
              },
            },
            // LIVE CLASS SCHEDULE
            {
              path: 'live-class-schedule',
              name: 'live-class-schedule',
              component: () => import('./views/pages/Report/LiveClassSchedule/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.report.title', default: "รายงาน" } },
                  { title: { i18n: 'sections.report.live-class-schedule.title', default: "รายงานบรรยายสด" }, active: true }
                ],
                pageTitle: 'sections.report.live-class-schedule.title',
              },
            },
            // EXAM
            {
              path: 'exam',
              name: 'exam',
              component: () => import('./views/pages/Report/Exam/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.report.title', default: "รายงาน" } },
                  { title: { i18n: 'sections.report.exam.title', default: "รายงานจำนวนข้อสอบ" }, active: true }
                ],
                pageTitle: 'sections.report.exam.title',
              },
            },
            // EXAM QUESTION
            {
              path: 'exam-question',
              name: 'exam-question',
              component: () => import('./views/pages/Report/ExamQuestion/index'),
              meta: {
                breadcrumb: [
                  {title: 'Home', url: '/'},
                  { title: { i18n: 'sections.report.title', default: "รายงาน" } },
                  { title: { i18n: 'sections.report.exam-question.title', default: "รายงานข้อสอบรายวิชา" }, active: true }
                ],
                pageTitle: 'sections.report.exam-question.title',
              },
            },
          ]
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/user',
          name: 'user',
          component: () => import('@/views/user'),
          redirect: '/user/login',
          children: [
            {
              path: 'login',
              name: 'user-login',
              component: () => import('@/views/user/Login')
            },
            {
              path: 'register',
              name: 'user-register',
              component: () => import('@/views/user/Register')
            },
            {
              path: 'forgot-password',
              name: 'user-forgot-password',
              component: () => import('@/views/user/ForgotPassword')
            },
            {
              path: 'change-password',
              name: 'user-change-password',
              props: true,
              component: () => import('@/views/user/ChangePassword')
            },
          ]
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

// eslint-disable-line no-unused-vars
router.beforeEach(async (from, to, next) => {
  //reload if not the same version as server
  const correctVersion = await checkServerVersion();
  if(correctVersion){
    next();
  }else{
    location.reload();
  }
});

export default router
